import React from 'react';
import { Tooltip, TooltipProvider } from '../../admin/components/shared/Tooltip.tsx';

export const FLOWCHART_DOCUMENT_CHECKBOX_CLASS =
  'mt-1 h-4 w-4 shrink-0 rounded border-gray-300 text-blue-600 focus:ring-blue-500 disabled:cursor-not-allowed disabled:opacity-50';

export type FlowchartDocumentCheckboxProps = {
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
  ariaLabel: string;
  tooltip?: string | null;
};

/** Shared checkbox for flowchart document selection (library rows). */
export function FlowchartDocumentCheckbox({
  checked,
  disabled = false,
  onChange,
  ariaLabel,
  tooltip = null,
}: FlowchartDocumentCheckboxProps): React.ReactElement {
  const input = (
    <input
      type="checkbox"
      checked={checked}
      disabled={disabled}
      onChange={(event) => onChange(event.target.checked)}
      className={FLOWCHART_DOCUMENT_CHECKBOX_CLASS}
      aria-label={ariaLabel}
    />
  );

  if (tooltip) {
    return (
      <TooltipProvider>
        <Tooltip content={tooltip} side="top">
          <span className="inline-flex">{input}</span>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return input;
}
